import React, { useEffect } from "react";
import "./Seva_Logbook_History.css";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import Light_Black_Btn from "../common/common_btn/light_black_btn/Light_Black_Btn";
import Pink_Btn from "../common/common_btn/pink_btn/Pink_Btn";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../features/admin/volunteerdetail/volunteer/Slice";
import { IDS } from "../../utils/IDS";
import { encodeId } from "../../utils/common";

const Seva_Logbook_History = () => {
  const data = [
    {
      title: "Volunteering as and at:",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img2.png",
    },
    {
      title: "Volunteering as and at:",
      address:
        "Om Tapovan Charitable Trust Borbhatha (Bet), Golden Bridge, Bharuch, Dist. Ankleshwar, Gujarat 393002 India",
      location: "Ankleshwar, India",
      lang: "Gujarati",
      date: "4 AUG 2025, 12:00 pm",
      img: "/assets/images/event_registration/near_by_events/img2.png",
    },
  ];

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const volunteer = useSelector((state) => state.volunteers);

  useEffect(() => {
    dispatch(GetAll());
  }, [dispatch]);

  const volunteers = volunteer?.data?.data || [];
  const getFullAddress = (centre) => {
    if (!centre) return "Address not available";

    return [
      centre?.address,
      centre?.Area?.name,
      centre?.City?.name,
      centre?.State?.name,
      centre?.Country?.name,
      centre?.Pincode?.pincode,
    ].filter(Boolean).join(", ");
  };

  const getCityState = (centre) => {
    if (!centre) return "";

    return [
      centre?.City?.name,
      centre?.State?.name,
    ].filter(Boolean).join(", ");
  };


  return (
    <section className="Seva_Logbook Seva_Logbook_History">
      <div className="container">
        <Common_Back_Header backNavigation={"/seva-logbook"} />

        <div className="content_div">
          <div className="all_programs_div">
            {volunteers.map((item) => {
              const centre = item?.Volunteering?.Contact_us_centre;

              const image = item?.Volunteering?.image
                ? IDS.IMG_URL + item.Volunteering.image
                : "/assets/images/default.jpg";

              return (
                <div className="program_card" key={item.id}>
                  <div className="row align-items-center">
                    <div className="col-xl-2 col-md-2 col-sm-7 col-6 mb-md-0 mb-sm-3">
                      <div className="left_img_div">
                        <img src={image} className="left_img" />
                      </div>
                    </div>

                    <div className="col-xl-8 col-md-7 order-md-2 order-sm-3">
                      <div className="content_div">

                        {/* Name */}
                        <p className="title_text">
                          {item?.User?.name}
                        </p>

                        {/* Position */}
                        <div className="img_text_div">
                          <img
                            src="/assets/images/event_registration/near_by_events/user.png"
                            className="inner_img"
                          />
                          <p className="inner_text">
                            {item?.Volunteers_Detail?.Volunteer_Position?.name || "N/A"}
                          </p>
                        </div>

                        {/* Full Address */}
                        <div className="img_text_div">
                          <img
                            src="/assets/images/event_registration/near_by_events/location.png"
                            className="inner_img"
                          />
                          <p className="inner_text">
                            {getFullAddress(centre)}
                          </p>
                        </div>

                        {/* City + State */}
                        <div className="img_text_div without_mb">
                          <img
                            src="/assets/images/event_registration/near_by_events/bank.png"
                            className="inner_img"
                          />
                          <p className="inner_text">
                            {getCityState(centre)}
                          </p>
                        </div>

                      </div>
                    </div>

                    <div className="col-xl-2 col-md-3 col-sm-5 order-md-3 order-sm-2">
                      <div className="right_div">
                        <Pink_Btn
                          btnText={"Details"}
                          onClick={() => navigate(`/seva-logbook-details/${encodeId(item?.id)}`)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </div>
    </section>
  );
};

export default Seva_Logbook_History;
